export default __webpack_public_path__ + "illustration-furniture.a45c0568861785d61635fd945650c275.png";